module.exports = __webpack_public_path__ + "0f04bbd2f2a4528f4bb0d6ae55478ca1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/lichtblauw.mp3
// module id = 33
// module chunks = 0